import { API } from '../api'
import { UnitsResponse } from './interface'

export const upload = async (
  file: File,
  collectId: string
): Promise<{
  conteudo: string
  sucesso: boolean
  erro?: string
}> => {
  const formData = new FormData()
  formData.append('arquivo', file)

  try {
    const response = await API.post<UnitsResponse>(
      `/logistica/agrupamento/vincular/${collectId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )

    return {
      conteudo: response.content,
      sucesso: response.isSuccess
    }
  } catch (error) {
    console.error('Erro ao enviar arquivo:', error)
    return {
      conteudo: null,
      sucesso: false,
      erro: error
    }
  }
}
